import React, { useContext, useMemo } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

import { AuthContext } from '../contexts/authContext';
import { useSelectedCarrier } from '../hooks/apiHooks';
import Layout from '../layout';
import { UserRole } from '../models/User';

/**
 * renders a single Layout instance for all carrier routes under
 * /carrier/:carrierId and /audit/carrier/:carrierId
 * so Layout stays mounted when navigating between carrier tabs.
 */
const CarrierLayoutWrapper = ({ carrierSubRoutes, routes }) => {
  const { pathname } = useLocation();
  const { authUser } = useContext(AuthContext);
  const { selectedCarrier } = useSelectedCarrier();

  const isAdmin = useMemo(
    () => authUser && [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(authUser.role),
    [authUser]
  );

  const menuIndex = isAdmin ? 1 : 0;
  const isViewRates = /^\/carrier\/[^/]+\/?$/.test(pathname);
  const isAuditRates = /^\/audit\/carrier\/[^/]+\/?$/.test(pathname);
  const isCostPerKm = /^\/carrier\/[^/]+\/cost-per-km$/.test(pathname);
  const skipFullPageLoader = isViewRates || isAuditRates || isCostPerKm;

  return (
    <Layout
      disableLoading
      carrierLoading={!selectedCarrier}
      menuIndex={menuIndex}
      routes={routes}
      showCarriersNavigation={isAdmin}
      skipFullPageLoader={skipFullPageLoader}
    >
      <Switch>
        {carrierSubRoutes.map((route) => (
          <Route
            key={route.path}
            exact={route.exact}
            path={route.path}
            render={() => <route.component disableLayout routes={routes} />}
          />
        ))}
      </Switch>
    </Layout>
  );
};

export default CarrierLayoutWrapper;

